import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type Options = {
  sectionRef: React.RefObject<HTMLDivElement>;
};

export default function useScrollAfterRedirect(options: Options) {
  const { sectionRef } = options;
  const navigate = useNavigate();
  const location = useLocation();
  const { state, pathname, search } = location;

  useEffect(() => {
    if (!state?.withScroll || !sectionRef.current) return;

    // scroll to section
    sectionRef.current.scrollIntoView();

    // remove withScroll from state
    const { withScroll, ...other } = state;

    navigate(`${pathname}${search}`, { replace: true, state: { ...other } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.withScroll]);

  return null;
}
